import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetUsers } from '../../../../hooks/services/sBook/useOfClient';
import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import CDropDownList from '../../../Common/CDropDownList';
import { deletePartyUserById, getPartyUserById, saveUsersByBookId, updatePartyUserById } from "../../../../services/sBook/party.service";
import List from "../../../Templates/List"
import { Dropdown } from '@fluentui/react';
import { useGetUsersByPartyId } from '../../../../hooks/services/sBook/useOfParty';
import Message from '../../../Common/Message';
import ListPagination from '../../../Templates/List/ListPagination';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { __BookRoles, enum__BookRoles } from '../../../../common/Dictionaries';
import { disableSectionPartyUserById } from '../../../../services/sBook/section-party.service';
import { cloneDeep } from 'lodash-es';

const SidePanelUsers = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ?  props.editMode : false;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;

    const inputParam_LeId = props.leId;
    const inputParam_BuId = props.buId;
    const inputParam_BookId = props.bookId;
    const inputParam_PartyId = props.partyId;
    const inputParam_BookRoleList = props.roleList;
    const inputParam_SetterUpdateUserCount = props.setterUpdateUserCount;

    const buttonAddStyles = { root: { float: "right" } };
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [message, setMessage] = useState(null);
    const [showMessage, setShowMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    
    const [selectedRoleId, setSelectedRoleId] = useState(__BookRoles.find(x => x.partyMemberRoleCode === enum__BookRoles.Configure).id);
    const [selectedRoleName, setSelectedRoleName] = useState("Asesor administrativo");
    
    const [isInvalidList, setIsInvalidList] = useState(false);


    const [bookUserList, setBookUserList] = useState(null);
    useGetUsers(inputParam_LeId, inputParam_BuId, bookUserList, setBookUserList);

    const [clientUserList, setClientUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    useGetUsersByPartyId(inputParam_PartyId, clientUserList, setClientUserList, inputParam_IsPanelOpen, false, true)


    



    const [selectedPickerUsers, setSelectedPickerUsers] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});


    const [isInvalidUserSelector, setIsInvalidUserSelector] = useState(false);
    const [isInvalidRoleSelector, setIsInvalidRoleSelector] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);
    const [itemToEdit, setItemToEdit] = useState(null);


    
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setIsInvalidList(false);
        setIsInvalidUserSelector(false);
        setIsInvalidRoleSelector(false);
        setShowMessage(false);
        setSelectedRoleName("Asesor administrativo");
        setSelectedRoleId(__BookRoles.find(x => x.partyMemberRoleCode === enum__BookRoles.Configure).id);
        
        setClientUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
    };

    const onSaveUsers = () => {
        const isValidForm = clientUserList.data !== null && clientUserList.data.length > 0;

        if (isValidForm) {
            let usersToSave = [];

            clientUserList.data.forEach(member => {
                usersToSave.push({
                    id: member.id,
                    partyId: inputParam_PartyId,
                    partyMemberRoleId: parseInt(member.partyMemberRoleId),
                    username: member.username,
                    userAuthProfileId: member.userAuthProfileId !== null && member.userAuthProfileId !== undefined ? member.userAuthProfileId : 0,
                    deactivate: member.deactivate,
                    mainUser: member.mainUser,
                    backupUser: member.backupUser
                })
            });

            saveUsersByBookId(inputParam_BookId, inputParam_PartyId, usersToSave).then((response) => {
                //No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
                //Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
                //setClientUserList(null);
                setClientUserList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: null
                }));
                setSelectedPickerUsers(prevState => ({
                    ...prevState,
                    data: null
                }));

                setBookUserList(null);
                setIsInvalidUserSelector(false);
                inputParam_SetterUpdateUserCount && inputParam_SetterUpdateUserCount(inputParam_PartyId, clientUserList.data.length);

                //setShowMessage(true)
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
            //Enviar a guardar los usuarios seleccionados en la lista de distribución de la parte en el libro.

            setIsInvalidUserSelector(false);
            setIsInvalidRoleSelector(false);
            onDismissPanel();
        }
        else {
            setIsInvalidList(true)
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setClientUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: null
        }));
    };
    
    const onClosePanel = () => {
        //No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
        //Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
        //setClientUserList(null);
        onDismissPanel();
    };

    const onChangeUser = (currentNode, selectedNodes) => {
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: selectedNodes
        }));

        bookUserList.forEach(x => {
            x.checked = x.username === currentNode.username ? currentNode.checked : x.checked;
        })

        setBookUserList(bookUserList);
        setIsInvalidUserSelector(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            {
                inputParam_EditMode && inputParam_UserHasConfigRoleAction && clientUserList.data && clientUserList.data.length > 0 &&
                <PrimaryButton onClick={ onSaveUsers } styles={_global_buttonStyles}>{t('data-lang-btn-save')}</PrimaryButton>
            }
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    }

    const onAddUserToUserList = () => {
        const isValidUserSelector = selectedPickerUsers.data !== null && selectedPickerUsers.data.length > 0;
        const isValidRoleSelector = selectedRoleId !== null;

        if (isValidUserSelector && isValidRoleSelector) {
 
            let idFlyItems = clientUserList.data.length > 0 ? clientUserList.data.reduce(function(prev, curr) {
                return parseInt(prev.id) < parseInt(curr.id) ? prev : curr;
            }) : null;

            for (let index = 0; index < selectedPickerUsers.data.length; index++) { 
                let _aux_index = index + 1;

                let element = selectedPickerUsers.data[index]
                let aux_index = idFlyItems !== null ? ((parseInt(idFlyItems.id) > 0)? _aux_index : parseInt(idFlyItems.id - _aux_index)) : 1;

                let duplicated = clientUserList.data.find(x => x.username === element.username);

                if(duplicated === null || duplicated === undefined) {
                    clientUserList.data.push({
                        deactivate: false,
                        emailuser: element.emailUser,
                        fullname: element.fullName,
                        id: aux_index * -1,
                        partyId: 0,
                        partyMemberRoleId: parseInt(selectedRoleId),
                        partyName: "",
                        roleName: inputParam_BookRoleList.find(x => x.id === parseInt(selectedRoleId)).name,
                        userAuthProfileId: element.id,
                        username: element.username,
                        
                        label: "Pablo Matuszalen: pablo.matus@tripontis.com"
                    });
                }
                else {
                    setShowMessage(true)
                    setMessageType("warning");
                    setMessage(t('data-lang-msg-someitemsalredyexist'))
                }
            }            

            setClientUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: clientUserList.data
            }));
            
            setSelectedPickerUsers(prevState => ({
                ...prevState,
                data: null
            }));

            bookUserList.map(x => x.checked = false)
            setBookUserList(bookUserList);

            setIsInvalidUserSelector(false);
            setIsInvalidRoleSelector(false);
            setIsInvalidList(false);
        }
        else {
            setIsInvalidUserSelector(!isValidUserSelector);
            setIsInvalidRoleSelector(!isValidRoleSelector);
        }
    }

    const onDeleteUserFromListClick = (item, setItemToDelete) => {
        if (item.id > 0) {
            deletePartyUserById(item.id).then((response) => {
                //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
                //De lo contrario tendría dos cosas iguales.
                if (response.data.succeeded) {

                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))

                    setItemToDelete(item);
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setItemToDelete(item);
        }
    }

    const onCancelRowClick = (item) => {
        getPartyUserById(inputParam_BookId, item.id).then((serviceResponse) => {
            setShowMessage(true)
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))

            clientUserList.data.forEach(element => {
                if (item.id === element.id) {
                    element = serviceResponse.data.data;
                }
            });
    
            setClientUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: clientUserList.data
            }));
    
            ManipulateRowButtonsDisplay(item.id);

        }).catch(() => {
            setShowMessage(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    };

    const onEditUserFromListClick = (item, setItemToEdit) => {
        //Cambiar clase de cell para que se habilite control textbox.
        ManipulateRowButtonsDisplay(item.id)
    }

    const ManipulateRowButtonsDisplay = (itemId) => {
        let elementsRowView = document.getElementsByClassName(`rowView${itemId}`);
        let elementsRowEdit = document.getElementsByClassName(`rowEdit${itemId}`);
        let elementBtnMantSave = document.getElementById(`btnMantSave${itemId}`);
        let elementBtnMantEdit = document.getElementById(`btnMantEdit${itemId}`);
        let elementBtnMantCancel = document.getElementById(`btnMantCancel${itemId}`);
        
        const isHiddenItem = elementsRowView[0].style.display === "none";

        if (isHiddenItem) {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });

            elementBtnMantSave.style.display = "none";
            elementBtnMantCancel.style.display = "none";
            elementBtnMantEdit.style.display = "block";
        }
        else {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });

            elementBtnMantSave.style.display = "block";
            elementBtnMantCancel.style.display = "block";
            elementBtnMantEdit.style.display = "none";
        }
    }
    const onChangeRoleType = (ev, item) => {
        for (let index = 0; index < clientUserList.data.length; index++) {
            const element = clientUserList.data[index];
            if (ev.target.id.indexOf(`ddlType${element.id}`) !== -1) {
                element["partyMemberRoleId"] = item.key
            }
        }

        setClientUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: clientUserList.data
        }));
    }

    const onDisableUserFromBookClick = (item) => {
        disableSectionPartyUserById(item.id).then((response) => {
            //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
            //De lo contrario tendría dos cosas iguales.

            if (response.data.data) {
                const itemFound = clientUserList.data.find(x => x.id === item.id);
                itemFound.deactivate = !item.deactivate;
                setClientUserList(cloneDeep(clientUserList));
            }
            else {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }
        }).catch((ex) => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    }

    const onSaveRowClick = (item, roleId) => {
        if (item.id > 0) {
            updatePartyUserById(item).then((response) => {
                //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
                //De lo contrario tendría dos cosas iguales.
                if (response.data.succeeded) {

                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))

                    setItemToEdit(item);
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setItemToEdit(item);
        }
    }

    //Por alguna razon el evento click que deberia borrar no funciona, no obtiene el valor de la lista de clientes, la obtiene con el valor inicial, que es nula.
    //Esta fue la unica forma en la que se pudo borrar el item. Posiblemente se vea en otros lugares esta misma implementacion. Buscar por #CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newUserList = [];

        clientUserList.data.forEach(obj => {
            if (obj.username !== itemToDelete.username) {
                newUserList.push(obj)
            }
        })

        setClientUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newUserList
        }));
        
        inputParam_SetterUpdateUserCount && inputParam_SetterUpdateUserCount(inputParam_PartyId, clientUserList.data.length - 1);

        setItemToDelete(null);
    }

    if (itemToEdit !== null) {
        clientUserList.data.forEach(obj => {
            if (obj.username === itemToEdit.username && obj.id === itemToEdit.id) {
                obj.partyMemberRoleId = itemToEdit.partyMemberRoleId
                obj.roleName = inputParam_BookRoleList.find(x => x.id === itemToEdit.partyMemberRoleId).name
                
                ManipulateRowButtonsDisplay(itemToEdit.id)
            }
        })

        setClientUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: clientUserList.data
        }));

        setItemToEdit(null);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-selectusersparty') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="40vw"
            >
                {
                    inputParam_EditMode === true && inputParam_UserHasConfigRoleAction &&
                    <>
                        <Row className="pt-3">
                            <Col>
                                <CDropDownList
                                    labelText={t('data-lang-lbl-role')}
                                    controlName="ddlUserRole"
                                    setterControlValue={ setSelectedRoleId }
                                    setterControlTextValue={ setSelectedRoleName }
                                    isInValid={ isInvalidRoleSelector }
                                    elementList={
                                        inputParam_BookRoleList !== null ? inputParam_BookRoleList : []
                                    }
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ bookUserList !== null ? bookUserList : [] }
                                    mode="multiSelect"
                                    className="dropdown-checkbox remove-position"
                                    isInValid={ isInvalidUserSelector }
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangeUser }
                                    labelText={ t('data-lang-lbl-bookusers') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidUserSelector } />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <PrimaryButton onClick={ onAddUserToUserList } styles={buttonAddStyles}>{t('data-lang-btn-add')}</PrimaryButton>
                            </Col>
                        </Row>
                    </>
                }
                <Row className="pt-3">
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="partyCreationUsers"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setClientUserList}
                            data={clientUserList}
                            columns={[
                                {
                                    key: 'username',
                                    name: t('data-lang-lbl-username'),
                                    fieldName: 'username',
                                    minWidth: 230,
                                    maxWidth: 230,
                                    onRender:(item) => {
                                        return <div title={item.emailuser}>{ item.fullname }</div>
                                    }
                                },
                                {
                                    key: 'roleName',
                                    name: t('data-lang-lbl-role'),
                                    fieldName: 'roleName',
                                    minWidth: 200,
                                    maxWidth: 200,
                                    onRender:(item) => {

                                        let _options = inputParam_BookRoleList !== null ?
                                        inputParam_BookRoleList : [];

                                        _options.map(x => {
                                            x.key = x.id;
                                            x.text = x.name;
                                            x.title = x.name;
                                        })

                                        return  <>
                                                    <Row className={`ps-2`}>
                                                        <Col className={`rowView${item.id}`} style={ {display: "block"} }>
                                                            <div>{ item.roleName }</div>
                                                        </Col>
                                                        <Col className={`rowEdit${item.id}`} style={ {display: "none"} }>
                                                            <Dropdown
                                                                id={`ddlType${item.id}`}
                                                                placeholder={t('data-lang-placeholder-selectoption')}
                                                                options={
                                                                    _options
                                                                }
                                                                selectedKey={ item.partyMemberRoleId }
                                                                onChange={ onChangeRoleType }
                                                                styles={ {title: { height: "27px" }} }
                                                                className="pt-1"
                                                                errorMessage={ t('data-lang-msg-required') }
                                                                required={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                    }
                                },
                                                                {
                                    key: 'deactivated',
                                    name: t('data-lang-lbl-deactivated'),
                                    fieldName: 'deactivate',
                                    minWidth: 98,
                                    maxWidth: 98,
                                    onRender:(item) => {
                                        return <div>{ item.deactivate ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return  <>
                                                {
                                                    inputParam_EditMode === true && inputParam_UserHasConfigRoleAction && <div className='d-flex'>           
                                                        {
                                                            item.id > 0 && 
                                                            <>
                                                                <ActionButton
                                                                    id={`btnMantEdit${item.id}`}
                                                                    iconProps={{ iconName: 'Edit' }}
                                                                    onClick={() => onEditUserFromListClick(item, setItemToDelete)}
                                                                    title={t('data-lang-btn-delete')}
                                                                    name={t('data-lang-btn-delete')}
                                                                    allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton
                                                                    id={`btnMantCancel${item.id}`}
                                                                    style={{display: "none"}}
                                                                    iconProps={{ iconName: 'Cancel' }}
                                                                    onClick={() => onCancelRowClick(item)}
                                                                    title={t('data-lang-btn-cancel')}
                                                                    name={t('data-lang-btn-cancel')}
                                                                    allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton
                                                                    id={`btnMantSave${item.id}`}
                                                                    style={{display: "none"}}
                                                                    iconProps={{ iconName: 'Save' }}
                                                                    onClick={() => onSaveRowClick(item)}
                                                                    title={t('data-lang-btn-save')}
                                                                    name={t('data-lang-btn-save')}
                                                                    allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton
                                                                    id={`btnMantDeactivate${item.id}`}
                                                                    iconProps={{ iconName: item.deactivate ? 'Blocked' : 'SkypeCircleCheck' }}
                                                                    onClick={() => onDisableUserFromBookClick(item)}
                                                                    title={item.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable')}
                                                                    name={item.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable')}
                                                                    allowDisabledFocus >
                                                                </ActionButton>
                                                            </>
                                                        }
                                                        <ActionButton
                                                            id={`btnMantDelete${item.id}`}
                                                            iconProps={{ iconName: 'Delete' }}
                                                            onClick={() => onDeleteUserFromListClick(item, setItemToDelete)}
                                                            title={t('data-lang-btn-delete')}
                                                            name={t('data-lang-btn-delete')}
                                                            allowDisabledFocus >
                                                        </ActionButton>
                                                    </div>
                                                }
                                                </>
                                    }
                                }
                            ]}
                        />
                        <CValidator isInValid={isInvalidList} />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-paginnation d-none">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="partyCreationUsers"
                            data={ clientUserList }
                            setData={ setClientUserList } />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelUsers;